// extracted by mini-css-extract-plugin
module.exports = {"labelValueRow":"LabelValueRow_labelValueRow_1Wzpt"};